import React from 'react';

import { PageBody } from '../components/PageBody';
import { PageHeading } from '../components/PageHeading';
import { PageMeta } from '../components/PageMeta';

import { useTrackPageView } from './hooks/useTrackPageView';

export const Layout: React.FC = () => {
	useTrackPageView();

	return (
		<div className="container">
			<PageMeta />
			<PageHeading />
			<PageBody />
		</div>
	);
};
